import { Flex, Skeleton, Divider } from '@eqi-investimentos/react';

export const HeaderSkeleton = () => {
  return (
    <>
      <Flex alignItems="center" gap="s">
        <Skeleton w="2.5rem" h="2.5rem" borderRadius="full" />
        <Flex direction="column" gap="xs">
          <Skeleton h="14px" w="90px" />
          <Skeleton h="12px" w="120px" />
        </Flex>
        <Skeleton ml="xs" boxSize="2rem" borderRadius="full" />
      </Flex>
      <Flex justifyContent="flex-end" alignItems="center" ml="auto" gap="xs">
        <Skeleton boxSize="2rem" borderRadius="full" />
        <Skeleton boxSize="2rem" borderRadius="full" />
      </Flex>
      <Divider
        orientation="vertical"
        h="3.5rem"
        borderColor="transparency.mid"
      />
      <Skeleton boxSize="2rem" borderRadius="full" />
    </>
  );
};
